export const toBooleanFromString = string => {
  if (string === "true") return true;
  if (string === "false") return false;
  return null;
};
